import React from 'react'
import './ConfirmModal.css'

/**
 * Modal de Confirmação Elegante
 * Substitui o window.confirm do navegador.
 * Com showCancelButton={false} vira modal de mensagem (apenas OK).
 */
const ConfirmModal = ({ show, title, message, onConfirm, onCancel, confirmText = 'Confirmar', cancelText = 'Cancelar', type = 'warning', zIndex, showCancelButton = true }) => {
  if (!show) return null

  const handleConfirm = () => {
    onConfirm?.()
  }

  const handleCancel = () => {
    onCancel?.()
  }

  const iconByType = {
    warning: '⚠️',
    danger: '🗑️',
    question: '❓',
    info: 'ℹ️',
    success: '✅',
    error: '❌'
  }

  return (
    <div className="confirm-modal-overlay" onClick={showCancelButton ? handleCancel : undefined} style={zIndex != null ? { zIndex } : undefined}>
      <div 
        className={`confirm-modal confirm-modal-${type}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="confirm-modal-header">
          <div className={`confirm-icon confirm-icon-${type}`}>
            {iconByType[type] || iconByType.warning}
          </div>
          <h3>{title}</h3>
        </div>

        <div className="confirm-modal-body">
          <p>{message}</p>
        </div>

        <div className="confirm-modal-footer">
          {showCancelButton && (
            <button 
              onClick={handleCancel}
              className="btn btn-cancel"
            >
              {cancelText}
            </button>
          )}
          <button 
            onClick={handleConfirm}
            className={`btn btn-confirm btn-confirm-${type}`}
            autoFocus
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  )
}

export default ConfirmModal

